import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeedbackResponseDTO } from '../../teacher-feedback/teacher-feedback-service/private-class-feedback-dto';
import { OeAppService } from '../oe-app.service';

@Injectable({
  providedIn: 'root',
})
export class LiveClassFeedbacksService {
  constructor(private http: HttpClient, private oeAppService: OeAppService) {}

  public getLiveClassFeedbackById(feedbackId: number) {
    return this.http.get<FeedbackResponseDTO>(
      `${this.oeAppService.courseServiceHost}/v1/liveclassfeedbacks/${feedbackId}`
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/live-class-feedbacks/live-class-feedbacks.service.ts